<template>
  <div class="answer-form form">
    <div class="field">
      <label class="label">Texto *</label>
      <div class="control">
        <input
          type="text"
          class="input"
          v-model="fData.text"
          maxlength="80"
          :disabled="isDisabled || disabledFields.text"
        >
        <div class="is-pulled-right">
          <char-count
            :countdown="80"
            :data-string="fData.text"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field field-correct">
      <label class="label checkbox">
        <!-- <checkbox
          v-model="fData.correct"
          :disabled="disabledFields.correct"
          :checked="fData.correct"
        /> -->
        <input
          type="checkbox"
          v-model="fData.correct"
          :disabled="isDisabled || disabledFields.correct"
          :checked="fData.correct"
        >
          Correta
        </label>
    </div>

    <slot name="after-form"></slot>

    <div class="field has-text-centered">
      <button
        class="button is-primary is-large"
        @click="onSubmit(fData)"
        :class="{ 'is-loading': isLoading }"
        :disabled="isDisabled || $v.fData.$invalid"
      >
        {{ButtonLabel || "Cadastrar"}}
      </button>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import FormMixin from './FormMixin'
import CharCount from '../CharCount'

export default {
  name: 'AnswerForm',
  mixins: [FormMixin],
  components: { CharCount },
  data () {
    return {
      fData: {
        text: '',
        correct: false
      }
    }
  },
  validations: {
    fData: {
      text: {
        required,
        maxLength: maxLength(80)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/AnswerForm.vue